import { createContext, useContext, useEffect } from 'react'

export type Position = {
	x: number
	y: number
}

export type PlaceItem = (position?: Position) => void

export const FLOOR_MAP_ITEM = 'application/x-floor-map-item'

export const PlacementContext = createContext<Map<string, PlaceItem> | null>(null)

export const usePlacement = (item: string, place: PlaceItem) => {
	const placements = useContext(PlacementContext)

	useEffect(() => {
		placements?.set(item, place)
	})

	useEffect(
		() => () => {
			placements?.delete(item)
		},
		[placements, item]
	)
}
